import React, { Component } from 'react';
import { Row, Col, Modal } from 'antd';
import { connect } from 'react-redux';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Modal
        title="客服"
        width={300}
        visible
        onCancel={this.props.cancel}
        maskClosable={false}
        footer={false}
      >
        <Row>
          <Col span={24}>
            <p>
              客户名称:<a style={{ marginLeft: '10px' }}>杭州先行科技</a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <p>
              维护客服:<a style={{ marginLeft: '10px' }}>锋锋</a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <p>
              签单员工:<a style={{ marginLeft: '10px' }}>企业QQ</a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <p>
              分配时间:<a style={{ marginLeft: '10px' }}>2017-12-05</a>
            </p>
          </Col>
        </Row>
      </Modal>
    );
  }
}
export default connect(state => ({ list: state.contract_type }))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ModalService.js